/* eslint-disable no-prototype-builtins */
import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import Cropper from 'react-easy-crop'

import { navbarHeight, footerHeight, dashboardNavbarHeight, cropAspectRatiosArray, positionChangeWidthSm } from '../../../helpers/variableDefaults'
import { saveAndCancelButtonsJSX, titleAndAdvisoryJSX } from '../../../helpers/commonJSX'
import { returnCroppedImage, uploadCroppedAWSFilesArray, returnSquareVideoThumbnail, urlToImageFile, fileToDataURL, getStartCropImageWidthsAndHeights, getCurrentImageWidthsAndHeights, getCurrentVideoWidthsAndHeights } from '../../../helpers/imageHandling'
import { advisoryTypography } from '../../../helpers/typographies'
import { standardButton } from '../../../helpers/buttons'
import { reloadView } from '../../../helpers/globalHelpers'
import { pinturaEditorDefaults, pinturaEditorJSX } from '../../../helpers/pinturaHelpers'
import { capitalizeFirstLetter } from '../../../helpers/globalHelpers'

import { seoPageTags, customAnalyticsEvent } from '../../../helpers/analytics'

// Crop Media Carousel Page
const CropNewMediaCarousel = ({ isDemo, fromComponent, newMediaArray, setNewMediaArray, mediaArray, setMediaArray, user, showCropCarousel, setShowCropCarousel, width }) => {
  // console.log('newMediaArray ->', newMediaArray)
  const isPintura = newMediaArray.filter(newMediaItem => newMediaItem.imageOrVideo === 'video').length > 0

  // Navigate
  const navigate = useNavigate()

  // Ref
  const editorRef = useRef(null)

  const [carouselIndex, setCarouselIndex] = useState(newMediaArray.findIndex(newMediaArrayItem => 'squareCropDataURL' in newMediaArrayItem && newMediaArrayItem.squareCropDataURL.length === 0))
  const [aspectRatioIndex, setAspectRatioIndex] = useState(0)
  const [trimCropIndex, setTrimCropIndex] = useState(0)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)

  // Loading
  const [loadingNewMedia, setLoadingNewMedia] = useState(false)
  const [creatingCropOrTrim, setCreatingCropOrTrim] = useState(false)

  // Errors
  const [errorNewMedia, setErrorNewMedia] = useState(false)

  // Save Successful
  const [saveSuccessfulNewMedia, setSaveSuccessfulNewMedia] = useState(false)

  
  useEffect(() => {
    // console.log('videoThumbnail useEffect runs')

  }, [creatingCropOrTrim])

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    // console.log('cropped area percentages ->', croppedArea)
    // console.log('cropped area pixels ->', croppedAreaPixels)

    const selectedMediaItemObj = { ...newMediaArray[carouselIndex] }
    selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].x = croppedAreaPixels.x
    selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].y = croppedAreaPixels.y
    selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].width = croppedAreaPixels.width
    selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].height = croppedAreaPixels.height

    const updatedMediaArray = [ ...newMediaArray ]
    updatedMediaArray[carouselIndex] = selectedMediaItemObj
    setNewMediaArray([ ...updatedMediaArray ])

  }

  const handleCancelPressed = () => {
    console.log('handleCancelPressed runs')
    
    if (
      saveSuccessfulNewMedia
      // || !saveSuccessfulNewMedia
    ) {
      navigate(`?media`, { state: { previousLocationPathname: `${window.location.pathname}?crop-media` } })
      reloadView()
    } else {
      setNewMediaArray([])
      setShowCropCarousel(false)
    }
  }

  const handlePinturaSavePressed = () => {
    console.log('handlePinturaSavePressed runs')
    if (!creatingCropOrTrim) {
      editorRef.current.editor.processImage()
      setCreatingCropOrTrim(true)
    }
  }

  const handleSavePressed = async (videoFile) => {
    // console.log('handleSavePressed runs')
    // console.log('videoFile ->', videoFile)
    // console.log('x ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].x)
    // console.log('y ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].y)
    // console.log('width ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].width)
    // console.log('height ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].height)

    // console.log('isPintura ->', isPintura)
    if (isPintura && newMediaArray[carouselIndex].imageOrVideo === 'video' && trimCropIndex === 0) {
      setCreatingCropOrTrim(true)
      // Set Media Item with Trimmed Data URL
      const selectedMediaItemObj = { ...newMediaArray[carouselIndex] }
      selectedMediaItemObj.file = videoFile
      selectedMediaItemObj.dataURL = await fileToDataURL(videoFile)
      const updatedMediaArray = [ ...newMediaArray ]
      updatedMediaArray[carouselIndex] = selectedMediaItemObj
      setNewMediaArray([ ...updatedMediaArray ])
      setTrimCropIndex(1)
      setCreatingCropOrTrim(false)
    } else {
      // Get Cropped Image
      // console.log('cropAspectRatiosArray[aspectRatioIndex].text ->', cropAspectRatiosArray[aspectRatioIndex].text)
      setCreatingCropOrTrim(true)
      if (newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropDataURL' : 'portraitCropDataURL'].length === 0) {
        const croppedDataURL = isPintura 
          ? 
          await fileToDataURL(videoFile)
          :
          await returnCroppedImage(
            newMediaArray[carouselIndex].dataURL,
            newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].x,
            newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].y,
            newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].width,
            newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].height
          )
        // console.log('croppedDataURL ->', croppedDataURL)
        // const croppedItemWidthAndHeight = newMediaArray[carouselIndex].imageOrVideo === 'image' ? await getCurrentImageWidthsAndHeights(croppedDataURL) : await getCurrentVideoWidthsAndHeights(videoFile)
        // console.log('croppedItemWidthAndHeight ->', croppedItemWidthAndHeight)
        const newCroppedFile = isPintura 
          ? 
          videoFile
          :
          await urlToImageFile(croppedDataURL, `crop-${carouselIndex}-${cropAspectRatiosArray[aspectRatioIndex].text}`)
          
        // Get video thumbnail and duration
        if (
          newMediaArray[carouselIndex].imageOrVideo === 'video'
          && cropAspectRatiosArray[aspectRatioIndex].text === 'square'
        ) {
          const newSquareVideoThumbnailAndDurationObj = await returnSquareVideoThumbnail(newCroppedFile)
          newMediaArray[carouselIndex].videoThumbnailURL = newSquareVideoThumbnailAndDurationObj.squareImage
          console.log('video thumbnail dimensions ->', await getCurrentImageWidthsAndHeights(newMediaArray[carouselIndex].videoThumbnailURL))
          newMediaArray[carouselIndex].duration = newSquareVideoThumbnailAndDurationObj.duration
          newMediaArray[carouselIndex].videoThumbnailFile = await urlToImageFile(newSquareVideoThumbnailAndDurationObj.squareImage, `video-thumbnail-${carouselIndex}`)
        }
        
        // Set Media Item with Cropped Data URL
        const selectedMediaItemObj = { ...newMediaArray[carouselIndex] }
        selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropDataURL' : 'portraitCropDataURL'] = croppedDataURL
        selectedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropFile' : 'portraitCropFile'] = newCroppedFile
        const updatedMediaArray = [ ...newMediaArray ]
        updatedMediaArray[carouselIndex] = selectedMediaItemObj
        setNewMediaArray([ ...updatedMediaArray ])
        // console.log('updatedMediaArray ->', updatedMediaArray)


        if (aspectRatioIndex < cropAspectRatiosArray.length - 1) {
          setAspectRatioIndex(aspectRatioIndex + 1)

          setCrop({ x: 0, y: 0 })
          setZoom(1)
          setCreatingCropOrTrim(false)
        } else if (carouselIndex < newMediaArray.length - 1) {
          setAspectRatioIndex(0)
          setCarouselIndex(carouselIndex + 1)
          if (isPintura && trimCropIndex !== 0) {
            setTrimCropIndex(0)
          }

          setCrop({ x: 0, y: 0 })
          setZoom(1)

          setCreatingCropOrTrim(false)
        } else {
          // console.log('newMediaArray ->', newMediaArray)
          console.log('updatedMediaArray ->', updatedMediaArray)

          if (isDemo) {
            console.log('this runs')
            if (isPintura && trimCropIndex !== 0) {
              setTrimCropIndex(0)
            }
            setShowCropCarousel(false)
            setNewMediaArray([])
          } else if (fromComponent === 'onboarding') {
            if (isPintura && trimCropIndex !== 0) {
              setTrimCropIndex(0)
            }
            setShowCropCarousel(false)
          } else if (newMediaArray.length > 0 && fromComponent === 'dashboardMediaTab') {
            setLoadingNewMedia(true)
            setErrorNewMedia(false)
      
            // Upload data
            try {
              // Upload Media — Use the updatedMediaArray for uploading because the state for newMediaArray hasn't updated with the final crop here
              const uploadedMedia = await uploadCroppedAWSFilesArray(updatedMediaArray, 'client', `${user.email.slice(0, user.email.indexOf('@'))}`, user._id, user.email, false)
              console.log('uploadedMedia ->', uploadedMedia)
      
              // Set New Media and Media Array
              if (
                uploadedMedia.length > 0 
                // && 
                // !(
                //   typeof uploadedMedia[0] === 'object' 
                //   && 'message' in uploadedMedia[0] 
                //   && (uploadedMedia[0].message === 'Media Upload Finished' || (uploadedMedia[0].message === 'Bucket not found'))
                // )
              ) {
                // setMediaArray([ ...mediaArray, ...uploadedMedia ])

                if (isPintura && trimCropIndex !== 0) {
                  setTrimCropIndex(0)
                }

                setSaveSuccessfulNewMedia(true)
                setErrorNewMedia(false)
                setLoadingNewMedia(false)
              } else {
                if (isPintura && trimCropIndex !== 0) {
                  setTrimCropIndex(0)
                }

                setErrorNewMedia(true)
                setLoadingNewMedia(false)
              }
            } catch (error) {
              console.log('error ->', error)

              if (isPintura && trimCropIndex !== 0) {
                setTrimCropIndex(0)
              }
      
              setErrorNewMedia(true)
              setLoadingNewMedia(false)
            }
          }
        }
      } 
    }
  }

  const cropChange = async (crop) => {
    // console.log('crop ->', crop)
    setCrop(crop)

  }

  const zoomChange = async (zoom) => {
    setZoom(zoom)
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {/* {seoPageTags(
        'CropNewMediaCarousel'
      )} */}

      {/* Body */}
      {(loadingNewMedia || errorNewMedia || saveSuccessfulNewMedia) ?
        <Box
          sx={{
            width: '100%',
            minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
            // minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight} - ${footerHeight})`,
            pb: 10,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {/* Loading */}
          {loadingNewMedia
            && !errorNewMedia
            && !saveSuccessfulNewMedia
            &&
            advisoryTypography(
              newMediaArray.filter(newMediaItem => newMediaItem.imageOrVideo === 'video').length === 0 ? 
                `Uploading Media...
                This may take a minute`
                :
                `Uploading Media...
                Video uploads can take a minute or two`
              , 
              'center'
            )
          }

          {/* Save Successful */}
          {saveSuccessfulNewMedia &&
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Upload Successful
            </Typography>
          }

          {/* Error */}
          {errorNewMedia &&
            <Typography
              textAlign={'left'}
              sx={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'red',
                maxWidth: '350px',
              }}
            >
              There was an error uploading your media. Check your Internet connection, read the Media Guidelines, and try again.
            </Typography>
          }

          {!loadingNewMedia && (saveSuccessfulNewMedia || errorNewMedia) &&
            standardButton(
              `OK`,
              'button',
              'contained',
              loadingNewMedia,
              'primary',
              2,
              1,
              0,
              '120px',
              '45px',
              handleCancelPressed
            )

          }

        </Box>
        :
        // newMediaArray[carouselIndex].imageOrVideo === 'image'
        // && 
        !isPintura
          ?
          <Box 
            sx={{ 
              minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`, 
              width: '100vw', 
              display: 'flex', flexDirection: 'column', justifyContent: width <= positionChangeWidthSm ? 'flex-start' : 'flex-start', alignItems: 'center', 
            }}
          >
            <Box
              sx={{
                width: '100%',
                // backgroundColor: 'pink',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Title */}
              <Box
                sx={{
                  mb: 1,
                  width: '100%',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    mt: 2,
                    // mb: 1,
                    fontSize: '18px',
                    fontWeight: 'bold',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'Square Crop' : 'Portrait Crop'}
                </Typography>
                <Typography
                  sx={{
                    fontStyle: 'italic',
                    color: 'blue',
                    fontSize: '16px',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? '*Hinge' : '*Bumble, Tinder'}
                </Typography>
              </Box>
              

              <Box
                sx={{
                  // backgroundColor: 'orange',
                  my: 1,
                  width: '300px',
                  height: '300px',
                  border: 2,
                  borderColor: 'black',
                }}
              >
                <Box
                  sx={{
                    height: '100%',
                    position: 'relative',
                  }}
                >
                  <Cropper
                    image={newMediaArray[carouselIndex].dataURL}
                    crop={crop}
                    zoom={zoom}
                    aspect={cropAspectRatiosArray[aspectRatioIndex].aspectRatio}
                    onCropChange={cropChange}
                    onCropComplete={onCropComplete}
                    onZoomChange={zoomChange}
                    objectFit={'cover'}
                  />
                </Box>
              </Box>
            </Box>

            {/* Save and Cancel Buttons */}
            {saveAndCancelButtonsJSX(
              false,
              creatingCropOrTrim,
              handleCancelPressed,
              handleSavePressed,
              1,
              5,
              1,
              'warning',
              ((carouselIndex < newMediaArray.length - 1) || (aspectRatioIndex < cropAspectRatiosArray.length - 1)) ? 'secondary' : 'primary'
            )}

          </Box>
          :
          <Box 
            sx={{ 
              minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`, 
              width: '100vw', 
              display: 'flex', flexDirection: 'column', justifyContent: width <= positionChangeWidthSm ? 'flex-start' : 'flex-start', alignItems: 'center', 
            }}
          >
            {/* Title */}
            <Box
              sx={{
                mb: 1,
                width: '100%',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  mt: 2,
                  fontSize: '18px',
                  fontWeight: 'bold',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {trimCropIndex === 0 && newMediaArray[carouselIndex].imageOrVideo === 'video' ? 'Video Trim' : `${capitalizeFirstLetter(cropAspectRatiosArray[aspectRatioIndex].text)} Crop`}
              </Typography>
              {trimCropIndex > 0 &&
                <Typography
                  sx={{
                    fontStyle: 'italic',
                    color: 'blue',
                    fontSize: '16px',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? '*Hinge' : '*Bumble, Tinder'}
                </Typography>
              }
            </Box>


            <Box
              sx={{
                height: '50vh',
                width: '100%',
              }}
            >
              {pinturaEditorJSX(
                editorRef, 
                newMediaArray[carouselIndex].dataURL, 
                (newMediaArray[carouselIndex].imageOrVideo === 'video' && trimCropIndex === 0) ? undefined : cropAspectRatiosArray[aspectRatioIndex].aspectRatio, 
                newMediaArray[carouselIndex].imageOrVideo, 
                trimCropIndex, 
                handleSavePressed
              )}
            </Box>


            {/* Save and Cancel Buttons */}
            {saveAndCancelButtonsJSX(
              false,
              creatingCropOrTrim,
              handleCancelPressed,
              handlePinturaSavePressed,
              (newMediaArray[carouselIndex].imageOrVideo === 'video' && trimCropIndex === 0) ? 0 : -2,
              5,
              1,
              'warning',
              ((carouselIndex < newMediaArray.length - 1) || (aspectRatioIndex < cropAspectRatiosArray.length - 1)) ? 'secondary' : 'primary'
            )}
          </Box>
      }
    </>
  )
}

export default CropNewMediaCarousel